import actions from "./actions";

const initState = {
  tablesOverview: [],
  dailyTurnOver: [],
  dailyTurnoverForPast8Days: [],
};

export default function dashboardReducer(
  state = initState,
  { type, ...action }
) {
  switch (type) {
    case actions.GET_TABLES_OVERVIEW_SUCCESS:
      return {
        ...state,
        tablesOverview: action.tablesOverview,
      };

    case actions.GET_DAILY_TURNOVER_SUCCESS:
      return {
        ...state,
        dailyTurnOver: action.dailyTurnOver,
      };

    case actions.GET_DAILY_TURNOVER_FOR_PAST_8_DAYS_BY_RESTAURANT_SUCCESS:
      return {
        ...state,
        dailyTurnoverForPast8Days:
          action.dailyTurnoverForPast8DaysByRestaurants,
      };

    default:
      return state;
  }
}
